import React from 'react'

import {
  StyleSheet,
  View,
} from 'react-native';
import RideViewer from '../components/ride/RideViewer';

interface Props {
}

const RideViewerScreen: React.FC<Props> = ({ 
}) => {   
  return ( 
    <View style={styles.container}>
      <RideViewer />
    </View>
  )
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    flex: 1,
    width: "100%"
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 20
  }
});

export default RideViewerScreen